import * as Yup from 'yup'

export function ValidateMessage(values) {
    return Yup.object().shape({
        body_message: Yup.string().required('This field is required'),
        status: Yup.string().required('This field is required'),
    });
}
